export const NUMBER_OF_USERS_CERTIFIED = 200000;